var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "Resident-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            "label-width": 80,
            model: _vm.edit,
            elem: _vm.residentElem,
            rules: _vm.residentRule,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "头像" } },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "avatar-uploader",
                          class: { hideUpload: _vm.hideUpload },
                          attrs: {
                            action: "#",
                            limit: 1,
                            "file-list": _vm.fileList,
                            "list-type": "picture-card",
                            "auto-upload": false,
                            "on-change": _vm.handleChange,
                            "on-preview": _vm.handlePreview,
                            "on-remove": _vm.handleRemove,
                            "before-upload": _vm.beforeAvatarUpload,
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon",
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip",
                            },
                            [
                              _vm._v(
                                "只能上传png/jpg/jpeg文件，且大小不超过2MB"
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "Modal",
                        {
                          attrs: {
                            width: "50%",
                            title: "预览",
                            styles: { top: "60px" },
                            footerHide: true,
                          },
                          model: {
                            value: _vm.dialogVisible,
                            callback: function ($$v) {
                              _vm.dialogVisible = $$v
                            },
                            expression: "dialogVisible",
                          },
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              display: "block",
                              "max-width": "100%",
                              margin: "0px auto",
                            },
                            attrs: { src: _vm.edit.face },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "姓名", prop: "name" } },
                    [
                      _c("Input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入学生姓名",
                          maxlength: "50",
                        },
                        model: {
                          value: _vm.edit.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "name", $$v)
                          },
                          expression: "edit.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "性别", prop: "gender" } },
                    [
                      _c(
                        "Select",
                        {
                          model: {
                            value: _vm.edit.gender,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "gender", $$v)
                            },
                            expression: "edit.gender",
                          },
                        },
                        _vm._l(_vm.enums.genderList, function (item) {
                          return _c(
                            "Option",
                            { key: item.code, attrs: { value: item.code } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 80,
                        label: "证件类型",
                        prop: "idCardType",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          on: { "on-change": _vm.changeIdCardType },
                          model: {
                            value: _vm.edit.idCardType,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "idCardType", $$v)
                            },
                            expression: "edit.idCardType",
                          },
                        },
                        _vm._l(_vm.enums.idCardTypes, function (item) {
                          return _c(
                            "Option",
                            { key: item.value, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 80,
                        label: "证件号码",
                        prop: "idCard",
                        required: _vm.edit.idCardType !== 2,
                      },
                    },
                    [
                      _c("Input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入证件号码",
                          maxlength: "20",
                          disabled: _vm.edit.idCardType === 2,
                        },
                        model: {
                          value: _vm.edit.idCard,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "idCard", $$v)
                          },
                          expression: "edit.idCard",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 80,
                        label: "出生日期",
                        prop: "birthday",
                        required: true,
                      },
                    },
                    [
                      _c("DatePicker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          value: _vm.edit.birthday,
                          editable: false,
                          type: "date",
                          format: "yyyy-MM-dd",
                          placeholder: "出生日期",
                        },
                        on: { "on-change": _vm.changeBirthday },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 80,
                        label: "手机号码",
                        prop: "phone",
                      },
                    },
                    [
                      _c("Input", {
                        attrs: {
                          type: "number",
                          placeholder: "请输入手机号码",
                          maxlength: "11",
                        },
                        model: {
                          value: _vm.edit.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "phone", $$v)
                          },
                          expression: "edit.phone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 80,
                        label: "固定电话",
                        prop: "phone",
                      },
                    },
                    [
                      _c("Input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入固定电话",
                          maxlength: "15",
                        },
                        model: {
                          value: _vm.edit.telPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "telPhone", $$v)
                          },
                          expression: "edit.telPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "民族", prop: "nationsId" } },
                    [
                      _c(
                        "Select",
                        {
                          model: {
                            value: _vm.edit.nationsId,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "nationsId", $$v)
                            },
                            expression: "edit.nationsId",
                          },
                        },
                        _vm._l(_vm.nationsList, function (item) {
                          return _c(
                            "Option",
                            { key: item.value, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 120,
                        label: "现住址",
                        prop: "currentAddress",
                      },
                    },
                    [
                      _c("Input", {
                        attrs: { type: "text", placeholder: "请输入现住址" },
                        model: {
                          value: _vm.edit.currentAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "currentAddress", $$v)
                          },
                          expression: "edit.currentAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 120,
                        label: "户籍地",
                        prop: "address",
                      },
                    },
                    [
                      _c("Input", {
                        attrs: { type: "text", placeholder: "请输入户籍地" },
                        model: {
                          value: _vm.edit.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "address", $$v)
                          },
                          expression: "edit.address",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 120,
                        label: "状态",
                        prop: "status",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          model: {
                            value: _vm.edit.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "status", $$v)
                            },
                            expression: "edit.status",
                          },
                        },
                        _vm._l(_vm.enums.status, function (item) {
                          return _c(
                            "Option",
                            { key: item.value, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c("Col", [
                _c(
                  "button",
                  {
                    staticClass: "ivu-btn ivu-btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.addFamilyMembers(1)
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-plus" }), _vm._v("新增亲属")]
                ),
              ]),
            ],
            1
          ),
          _vm.familyMembers && _vm.familyMembers.length > 0
            ? _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "23" } },
                    [
                      _c(
                        "vxe-table",
                        {
                          ref: "familyMember",
                          staticClass: "mytable-scrollbar",
                          staticStyle: { "margin-top": "10px" },
                          attrs: {
                            border: "",
                            "row-config": { isCurrent: true, isHover: true },
                            "custom-config": { storage: true, visible: true },
                            data: _vm.familyMembers,
                            "sort-config": { trigger: "cell" },
                          },
                        },
                        [
                          _vm._l(_vm.columns, function (item) {
                            return _c("vxe-column", {
                              attrs: {
                                field: item.key,
                                title: item.title,
                                visible: item.visible,
                                formatter: item.formatter ? item.formatter : "",
                                fixed: item.fixed ? item.fixed : "",
                                width: item.width,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        item.key == "type"
                                          ? _c(
                                              "Select",
                                              {
                                                staticStyle: {
                                                  "z-index": "9999",
                                                },
                                                attrs: {
                                                  placement: "top",
                                                  transfer: "",
                                                },
                                                model: {
                                                  value: row[item.key],
                                                  callback: function ($$v) {
                                                    _vm.$set(row, item.key, $$v)
                                                  },
                                                  expression: "row[item.key]",
                                                },
                                              },
                                              _vm._l(
                                                _vm.enums.familyMemberTypeList,
                                                function (item) {
                                                  return _c(
                                                    "Option",
                                                    {
                                                      key: item.code,
                                                      staticStyle: {
                                                        "z-index": "9999",
                                                      },
                                                      attrs: {
                                                        value: item.code,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.value))]
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          : item.key.indexOf("idcardType") !==
                                            -1
                                          ? _c(
                                              "Select",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  transfer: "",
                                                },
                                                model: {
                                                  value: row[item.key],
                                                  callback: function ($$v) {
                                                    _vm.$set(row, item.key, $$v)
                                                  },
                                                  expression: "row[item.key]",
                                                },
                                              },
                                              _vm._l(
                                                _vm.enums.idCardTypes,
                                                function (item) {
                                                  return _c(
                                                    "Option",
                                                    {
                                                      key: item.value,
                                                      attrs: {
                                                        value: item.value,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.label))]
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          : item.key == "idcard"
                                          ? _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入身份证",
                                                maxlength: "18",
                                                size: "mini",
                                              },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.idcardInput(row)
                                                },
                                              },
                                              model: {
                                                value: row[item.key],
                                                callback: function ($$v) {
                                                  _vm.$set(row, item.key, $$v)
                                                },
                                                expression: "row[item.key]",
                                              },
                                            })
                                          : item.key.indexOf("gender") !== -1
                                          ? _c(
                                              "Select",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  transfer: "",
                                                },
                                                model: {
                                                  value: row[item.key],
                                                  callback: function ($$v) {
                                                    _vm.$set(row, item.key, $$v)
                                                  },
                                                  expression: "row[item.key]",
                                                },
                                              },
                                              _vm._l(
                                                _vm.enums.genderList,
                                                function (item) {
                                                  return _c(
                                                    "Option",
                                                    {
                                                      key: item.code,
                                                      attrs: {
                                                        value: item.code,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          : item.key.indexOf("occupationId") !==
                                            -1
                                          ? _c(
                                              "Select",
                                              {
                                                attrs: {
                                                  placement: "top",
                                                  transfer: "",
                                                },
                                                model: {
                                                  value: row[item.key],
                                                  callback: function ($$v) {
                                                    _vm.$set(row, item.key, $$v)
                                                  },
                                                  expression: "row[item.key]",
                                                },
                                              },
                                              _vm._l(
                                                _vm.enums.occupationsList,
                                                function (item) {
                                                  return _c(
                                                    "Option",
                                                    {
                                                      key: item.code,
                                                      attrs: {
                                                        value: item.code,
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.value))]
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          : item.key.indexOf("birthday") !== -1
                                          ? _c("DatePicker", {
                                              attrs: {
                                                value: row[item.key],
                                                editable: false,
                                                type: "date",
                                                format: "yyyy-MM-dd",
                                                placeholder: "出生日期",
                                                placement: "top",
                                                transfer: "",
                                              },
                                              on: {
                                                "on-change": (val) => {
                                                  row.birthday = val
                                                },
                                              },
                                            })
                                          : _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入",
                                                maxlength: "125",
                                                size: "mini",
                                              },
                                              model: {
                                                value: row[item.key],
                                                callback: function ($$v) {
                                                  _vm.$set(row, item.key, $$v)
                                                },
                                                expression: "row[item.key]",
                                              },
                                            }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          }),
                          _c("vxe-column", {
                            attrs: {
                              title: "操作",
                              width: "180",
                              "show-overflow": "",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addFamilyMembers(
                                                -1,
                                                row.rowId
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("删除")]
                                      ),
                                      row.status == 2
                                        ? _c("span", [_vm._v("默认家属")])
                                        : _vm._e(),
                                      row.status == 1
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.setDefault(
                                                    row.rowId
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("设为默认家属")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2195566851
                            ),
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }